import React from "react";
import { useTranslation } from "react-i18next";

import phone from "../assets/images/phone/1.png";

export default function FeaturesTwo() {
  const { t } = useTranslation();

  // Define feature data with translations
  const feature2 = [
    {
      title: t("features.forum.title"),
      desc: t("features.forum.description"),
      icon: ({ className }: { className?: string }) => (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" />
        </svg>
      ),
    },
    {
      title: t("features.networking.title"),
      desc: t("features.networking.description"),
      icon: ({ className }: { className?: string }) => (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ),
    },
    {
      title: t("features.moderation.title"),
      desc: t("features.moderation.description"),
      icon: ({ className }: { className?: string }) => (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
        </svg>
      ),
    },
  ];

  const feature3 = [
    {
      title: t("features.verification.title"),
      desc: t("features.verification.description"),
      icon: ({ className }: { className?: string }) => (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      title: t("features.mobile.title"),
      desc: t("features.mobile.description"),
      icon: ({ className }: { className?: string }) => (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      title: t("features.marketplace.title"),
      desc: t("features.marketplace.description"),
      icon: ({ className }: { className?: string }) => (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="grid lg:grid-cols-12 md:grid-cols-12 grid-cols-1 mt-6 gap-6 lg:gap-8 items-center">
      {/* Left Column - Feature 2 */}
      <div className="lg:col-span-5 md:col-span-6 lg:order-1 order-2">
        <div className="grid grid-cols-1 gap-4 sm:gap-6">
          {feature2.map((item, index) => {
            let Icon = item.icon;
            return (
              <div
                className="group flex duration-500 p-3 sm:p-4 xl:p-3 hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded-xl transition-all"
                key={index}
              >
                <div className="flex md:order-2 order-1 align-middle justify-center items-center size-12 sm:size-14 md:size-16 mt-1 bg-red-500/5 dark:bg-red-500/10 group-hover:bg-primaryColor group-hover:text-white text-red-500 rounded-xl sm:rounded-2xl text-xl sm:text-2xl shadow-sm dark:shadow-gray-800 duration-500 flex-shrink-0">
                  <Icon className="size-4 sm:size-5" />
                </div>
                <div className="flex-1 md:order-1 order-2 md:text-end md:me-4 md:ms-0 ms-3 sm:ms-4 min-w-0">
                  <h4 className="mb-0 text-base sm:text-lg font-semibold leading-tight whitespace-nowrap md:text-right text-left">
                    {item.title}
                  </h4>
                  <p className="text-slate-400 mt-2 sm:mt-3 text-sm sm:text-base leading-relaxed md:text-right text-left">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Center Column - Phone Image */}
      <div className="hidden md:flex lg:col-span-2 md:col-span-12 lg:order-2 order-1 justify-center">
        <div className="relative">
          <img
            src={phone}
            className="mx-auto w-48 sm:w-56 md:w-64 lg:w-auto max-w-full h-auto object-contain"
            alt="Mobile app screenshot"
          />
        </div>
      </div>

      {/* Right Column - Feature 3 */}
      <div className="lg:col-span-5 md:col-span-6 order-3">
        <div className="grid grid-cols-1 gap-4 sm:gap-6">
          {feature3.map((item, index) => {
            let Icon = item.icon;
            return (
              <div
                className="group flex duration-500 p-3 sm:p-4 xl:p-3 hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded-xl transition-all"
                key={index}
              >
                <div className="flex align-middle justify-center items-center size-12 sm:size-14 md:size-16 mt-1 bg-red-500/5 dark:bg-red-500/10 group-hover:bg-primaryColor group-hover:text-white text-red-500 rounded-xl sm:rounded-2xl text-xl sm:text-2xl shadow-sm dark:shadow-gray-800 duration-500 flex-shrink-0">
                  <Icon className="size-4 sm:size-5" />
                </div>
                <div className="flex-1 ms-3 sm:ms-4 min-w-0">
                  <h4 className="mb-0 text-base sm:text-lg font-semibold leading-tight whitespace-nowrap">
                    {item.title}
                  </h4>
                  <p className="text-slate-400 mt-2 sm:mt-3 text-sm sm:text-base leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
